import { useQuery, QueryResult } from '@apollo/client'
import { Country, EmployeesAndTagsWithRankingDisabledQuery, EmployeesAndTagsWithRankingDisabledQueryVariables } from '../../types'
import { EMPLOYEES_AND_TAGS_WITH_RANKING_DISABLED } from './Queries'

export const useEmployeeAndTagsWithRankingDisabled = (
  companyId: string,
  country: Country,
): QueryResult<EmployeesAndTagsWithRankingDisabledQuery, EmployeesAndTagsWithRankingDisabledQueryVariables> => {
  return useQuery<EmployeesAndTagsWithRankingDisabledQuery, EmployeesAndTagsWithRankingDisabledQueryVariables>(
    EMPLOYEES_AND_TAGS_WITH_RANKING_DISABLED,
    {
      variables: { companyId, country },
      fetchPolicy: 'network-only',
    },
  )
}
